module.exports = __webpack_public_path__ + "static/media/download_cloud.19cf2c10.svg";